import React from "react";
import { Box, Flex, Image, Text as CText } from "@chakra-ui/react";
import { ReferFriend as refer } from "static/images";
import { Link } from "react-router-dom";
// TODO: Issue MRP-2775
// eslint-disable-next-line import/no-unresolved
import { ArrowRight } from "ui-kit/icon";

// TODO: Issue MRP-2775
// eslint-disable-next-line arrow-body-style
const NewFeaturePanel = () => {
  return (
    <Flex flexDir="row" shadow="0 -3pt 6pt hsla(0, 0%, 0%, 0.1)" borderTopRadius="10px">
      <Link to="/refer-friend/" style={{ width: "234px", height: "123px" }}>
        <Image src={refer} alt="Refer logo" width="134px" height="123px" borderTopRightRadius="8px" />
      </Link>
      <Box color="blue.darkest" padding="12px 26px 0px 20px" letterSpacing="0px">
        <CText fontSize="10px" lineHeight="12.5px" fontWeight="500" color="#6F7F98">
          NEW
        </CText>
        <CText fontSize="14px" lineHeight="20px" fontWeight="500" color="#2D3848">
          $100 Awaits You!
        </CText>
        <CText fontSize="14px" lineHeight="20px" fontWeight="500" color="#00252F" opacity="0.5">
          Refer your friends to us, get rewarded.
        </CText>
        <Link to="/refer-friend/">
          <Box display="flex" alignItems="center" marginBottom="6px" gap="2px">
            <CText fontSize="14px" fontWeight="500" color="#086883" textDecoration="underline">
              Refer Here
            </CText>
            <Box as={ArrowRight} width="7.5px" height="6.43" />
          </Box>
        </Link>
      </Box>
    </Flex>
  );
};

export default NewFeaturePanel;
